import styled from 'styled-components'
import Colors from 'builder/styles/colors'

export const Container = styled.div`
  > span {
    cursor: pointer;
    color: ${Colors.Blue50};
  }
`
